import { render, staticRenderFns } from "./CreateCoupon.vue?vue&type=template&id=048ad969&scoped=true&"
import script from "./CreateCoupon.vue?vue&type=script&lang=js&"
export * from "./CreateCoupon.vue?vue&type=script&lang=js&"
import style0 from "./CreateCoupon.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CreateCoupon.vue?vue&type=style&index=1&id=048ad969&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048ad969",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048ad969')) {
      api.createRecord('048ad969', component.options)
    } else {
      api.reload('048ad969', component.options)
    }
    module.hot.accept("./CreateCoupon.vue?vue&type=template&id=048ad969&scoped=true&", function () {
      api.rerender('048ad969', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/dialog/CreateCoupon.vue"
export default component.exports